<template>
  <div>
    <a-modal title="关联MRD" :visible="visible" :confirm-loading="loading" @cancel="onClose" @ok="onSubmit">
      <a-form-model ref="form" :model="form" :rules="rules" :label-col="{ span: 5 }" :wrapper-col="{ span: 18 }">
        <a-form-model-item ref="documentId" label="关联MRD" prop="documentId">
          <document-select v-model="form.documentId" :unbound="true" />
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </div>
</template>

<script>
import { associateDocument } from '@/api/business/document';
import DocumentSelect from '@/pages/business/requirement/components/DocumentSelect';

export default {
  components: { DocumentSelect },
  data() {
    return {
      loading: false,
      visible: false,
      form: {
        documentId: null,
        requirementId: null
      },
      rules: {
        documentId: [{ required: true, message: '关联MRD不能为空', trigger: 'change' }]
      }
    };
  },
  methods: {
    onClose() {
      this.visible = false;
      this.loading = false;
      this.$refs.form.resetFields();
    },

    onOpen(requirementId) {
      this.visible = true;
      this.form = { documentId: null, requirementId: requirementId };
    },
    onSubmit() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.loading = true;
          associateDocument({ ...this.form })
            .then(() => {
              this.loading = false;
              this.visible = false;
              this.$message.success('关联成功');
              this.$emit('saveOK');
            })
            .catch(() => {
              this.loading = false;
            });
        }
      });
    }
  }
};
</script>
